const HowToUseEmailTemplate = () => {
  return (
    <div className="w-full bg-white    space-y-4">
      {/* Header */}
      <div>
        <h2 className="font-semibold tracking-tight text-2xl text-gray-900">
          Create Email Template
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          This section allows you to create and customize an email template that
          you can reuse for your campaigns. You can manually edit the subject,
          email body, and footer or generate content using AI.
        </p>
      </div>

      {/* Step 1 */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">
          Step 1: Enter Prompt / Raw Email Content (Optional)
        </h3>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>Your email idea</li>
          <li>Raw email content</li>
          <li>A short description of what the email should be about</li>
        </ul>
        <p className="mt-2 text-sm text-gray-600">
          Click{" "}
          <span className="font-medium text-gray-900">Create with AI</span> to
          automatically generate:
        </p>
        <ul className="mt-1 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>Subject line</li>
          <li>Email body</li>
          <li>Footer content</li>
        </ul>
      </div>

      {/* Step 2 */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">
          Step 2: Update Subject Line
        </h3>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>Edit or write your email subject</li>
          <li>Use the character counter to stay within limits</li>
          <li>Keep it clear and engaging to improve open rates</li>
        </ul>
      </div>

      {/* Step 3 */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">
          Step 3: Customize Email Body
        </h3>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>Add or remove paragraphs</li>
          <li>Modify bullet points</li>
          <li>Insert dynamic placeholders such as:</li>
        </ul>

        <div className="mt-3 flex flex-wrap gap-2">
          {["{company_name}", "{cta_link}", "{email}", "{phone}"].map(
            (item) => (
              <span
                key={item}
                className="text-xs bg-gray-100 border border-gray-200 rounded-md px-2 py-1 font-mono text-gray-700"
              >
                {item}
              </span>
            )
          )}
        </div>

        <p className="mt-2 text-sm text-gray-600">
          The <span className="font-medium">Live HTML Preview</span> shows
          exactly how your email will appear.
        </p>
      </div>

      {/* Step 4 */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">
          Step 4: Add Email Footer (Optional)
        </h3>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>Closing message or signature</li>
          <li>
            Sender name: <span className="font-mono">{`{sender_name}`}</span>
          </li>
          <li>Contact details or brand message</li>
        </ul>
      </div>

      {/* Step 5 */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">
          Step 5: Preview Your Email
        </h3>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>Formatting and layout</li>
          <li>Text alignment</li>
          <li>Dynamic variable placement</li>
        </ul>
        <p className="mt-1 text-sm text-gray-600">
          Ensure everything looks correct before saving.
        </p>
      </div>

      {/* Step 6 */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">
          Step 6: Save Template
        </h3>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>
            Click <strong>Save as Template</strong>
          </li>
          <li>Reuse saved templates in future campaigns</li>
        </ul>
      </div>
    </div>
  );
};

export default HowToUseEmailTemplate;
